// extracted by mini-css-extract-plugin
module.exports = {"block":"Nav_block__pWGV8","item":"Nav_item__bdtLK"};